module.exports = __webpack_public_path__ + "img/why.57b8f6fc.svg";